export default "__VITE_ASSET__BFPOqtQq__"